import { Availability, ProviderTravel } from "@caredna-marlin/utils/client/availability";
import { FormControlLabel, Grid2 as Grid, MenuItem, Select, Switch, Typography } from "@mui/material";
import { useOrgConfig } from "~/providers/OrgConfigProvider";

type Props = {
  disabled?: boolean,
  edited: Availability,
  setEdited: (a: Availability) => void,
}

const EditAvailabilityAvailable = ({ disabled, edited, setEdited }: Props) => {
  const { shiftCenters } = useOrgConfig();

  return <>
    <Grid size={3}><span>Visits {!edited.providerTravel && <Typography color="error" component="span">*</Typography>}</span></Grid>
    <Grid size={9}>
      <Grid container spacing={2}>
        <Grid size={5}>
          <Select
            sx={{ width: "100%" }}
            disabled={disabled}
            value={edited.providerTravel || ""}
            onChange={(e) => setEdited({...edited, providerTravel: e.target.value as ProviderTravel })}
            required
          >
            <MenuItem value="inHomeOnly">In-Home</MenuItem>
            <MenuItem value="virtualOnly">Virtual</MenuItem>
            <MenuItem value="either">In-Home or Virtual</MenuItem>
          </Select>
        </Grid>
        <Grid size={7}>
          <FormControlLabel
            label="Overflow Shift"
            control={<Switch
              checked={edited.overflowShift}
              disabled={disabled}
              onChange={(e) => setEdited({
                ...edited,
                overflowShift: e.target.checked,
              })}
            />}
          />
        </Grid>
      </Grid>
    </Grid>

    <Grid size={3}><span>Shift Center</span></Grid>
    <Grid size={9}>
      <Grid container spacing={2}>
        <Grid size={5}>
          <Select
            sx={{ width: "100%" }}
            value={edited.shiftCenterId || 0}
            disabled={disabled}
            onChange={(e) => setEdited({...edited, shiftCenterId: e.target.value ? Number(e.target.value) : null})}
          >
            <MenuItem value={0}>Provider Home</MenuItem>
            {Object.values(shiftCenters).filter(s => s !== undefined).map(s => <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>)}
          </Select>
        </Grid>
        <Grid size={7}>
          {edited.shiftCenterId && <FormControlLabel
            label="Use for Drive Times"
            control={<Switch
              checked={edited.useShiftCenterDriveTimes}
              disabled={disabled}
              onChange={(e) => setEdited({
                ...edited,
                useShiftCenterDriveTimes: e.target.checked,
              })}
            />}
          />}
        </Grid>
      </Grid>
    </Grid>
  </>
}

export default EditAvailabilityAvailable;
